export const COMP_METRICS = [
  ["vizite_login", "Vizite intrare"],
  ["login_auth", "Login auth"],
  ["login_guest", "Login guest"],
  ["click_obloane", "Click Obloane"],
  ["click_scanx", "Click ScanX"],
  ["click_config", "Click Configurator"],
  ["oferte_oblon", "Oferte Oblon"],
  ["oferte_scanx", "Oferte ScanX"],
  ["oferte_config", "Oferte Configurator"],
  ["utilizatori_distrib", "Utilizatori noi distribuitori"],
  ["utilizatori_guest", "Utilizatori noi guest"],
  ["click_simpl_oblon", "Click Simpl. Oblon"],
  ["click_simpl_fu", "Click Simpl. Fer/Usi"],
  ["oferte_simpl_oblon", "Oferte Simpl. Oblon"],
  ["oferte_simpl_fu", "Oferte Simpl. Fer/Usi"],
  ["click_simpl_constructii", "Click Simpl. Fundatii"],
  ["click_config_constructii", "Click Config. Fundatii"],
];

const PIE_COLORS = [
  "#3b82f6", "#8b5cf6", "#f59e0b", "#10b981", "#ef4444", "#ec4899",
  "#14b8a6", "#a855f7", "#f97316", "#22c55e", "#6366f1", "#0ea5e9",
  "#eab308", "#d946ef", "#06b6d4", "#84cc16", "#f43f5e", "#64748b",
];

export const colorOf = (name, idx) => (name === "Necunoscut" ? "#94a3b8" : PIE_COLORS[idx % PIE_COLORS.length]);
